import type { TlsAcmeData, TlsCertificateData, TlsData } from "./types.js";
import { DataModel } from "../../base/index.js";
import { Certificate } from "../Certificate/index.js";
import { DateTime } from "luxon";

abstract class TlsBase<T extends TlsData> extends DataModel<T> {
  public constructor(data: T) {
    super(data);
  }
}

export class TlsCertificate extends TlsBase<TlsCertificateData> {
  public readonly type = "certificate";
  public readonly certificate: Certificate;

  public constructor(data: TlsCertificateData) {
    super(data);
    this.certificate = Certificate.ofId(data.certificateId);
  }
}

export class TlsAcme extends TlsBase<TlsAcmeData> {
  public readonly type = "acme";
  public readonly acme: boolean;
  public readonly isCreated: boolean;
  public readonly requestDeadline: DateTime | undefined;
  public constructor(data: TlsAcmeData) {
    super(data);
    this.acme = data.acme;
    this.isCreated = data.isCreated;
    this.requestDeadline = data.requestDeadline
      ? DateTime.fromISO(data.requestDeadline)
      : undefined;
  }
}

export type Tls = TlsAcme | TlsCertificate;

export const tlsFactory = (data: TlsData): Tls => {
  if ("certificateId" in data) {
    return new TlsCertificate(data);
  }
  return new TlsAcme(data);
};
